import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-1.5" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-start gap-2"
}
const _hoisted_3 = {
  class: "flex h-7 w-7 shrink-0 items-center justify-center rounded-catering-sm bg-catering-lemon-100 shadow-catering-xs",
  "aria-hidden": "true"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "whitespace-pre-line" }
const _hoisted_6 = {
  key: 2,
  class: "text-right text-xs text-catering-berry-500"
}

import { SparklesIcon } from '@heroicons/vue/24/solid'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import BotCategoryList from '@/components/catering/bottleBot/cards/BotCategoryList.vue'
import BotCustomerContact from '@/components/catering/bottleBot/cards/BotCustomerContact.vue'
import BotCustomerSegments from '@/components/catering/bottleBot/cards/BotCustomerSegments.vue'
import BotDeliveryZone from '@/components/catering/bottleBot/cards/BotDeliveryZone.vue'
import BotDiscountCodeList from '@/components/catering/bottleBot/cards/BotDiscountCodeList.vue'
import BotEcommerceOrderSummary from '@/components/catering/bottleBot/cards/BotEcommerceOrderSummary.vue'
import BotError from '@/components/catering/bottleBot/cards/BotError.vue'
import BotFeeConfig from '@/components/catering/bottleBot/cards/BotFeeConfig.vue'
import BotFulfillmentMethodList from '@/components/catering/bottleBot/cards/BotFulfillmentMethodList.vue'
import BotGeocodingCoverage from '@/components/catering/bottleBot/cards/BotGeocodingCoverage.vue'
import BotInventoryReport from '@/components/catering/bottleBot/cards/BotInventoryReport.vue'
import BotLineItemBreakdown from '@/components/catering/bottleBot/cards/BotLineItemBreakdown.vue'
import BotMenuList from '@/components/catering/bottleBot/cards/BotMenuList.vue'
import BotMethodList from '@/components/catering/bottleBot/cards/BotMethodList.vue'
import BotOrderAddress from '@/components/catering/bottleBot/cards/BotOrderAddress.vue'
import BotOrderSummary from '@/components/catering/bottleBot/cards/BotOrderSummary.vue'
import BotOrderTotalBreakdown from '@/components/catering/bottleBot/cards/BotOrderTotalBreakdown.vue'
import BotPricingTierList from '@/components/catering/bottleBot/cards/BotPricingTierList.vue'
import BotProductDetail from '@/components/catering/bottleBot/cards/BotProductDetail.vue'
import BotProductList from '@/components/catering/bottleBot/cards/BotProductList.vue'
import BotShortfallLogged from '@/components/catering/bottleBot/cards/BotShortfallLogged.vue'
import BotSlotProducts from '@/components/catering/bottleBot/cards/BotSlotProducts.vue'
import BotSlotSchedule from '@/components/catering/bottleBot/cards/BotSlotSchedule.vue'
import BotSmartlistDiagnosis from '@/components/catering/bottleBot/cards/BotSmartlistDiagnosis.vue'
import BotSmartlistList from '@/components/catering/bottleBot/cards/BotSmartlistList.vue'
import BotSmsOptOutSummary from '@/components/catering/bottleBot/cards/BotSmsOptOutSummary.vue'
import BotStoreProfile from '@/components/catering/bottleBot/cards/BotStoreProfile.vue'
import BotTaxSetup from '@/components/catering/bottleBot/cards/BotTaxSetup.vue'
import { botLinkTarget, resolveBotLinks } from '@/helpers/botLinks'
import { renderBotMarkdown } from '@/helpers/botMarkdown'
import { messageBubbleClasses } from '@/helpers/botMessageList'
import { normalizeRenderBlock, renderBlockComponent } from '@/helpers/botRenderBlocks'
import { canAccessRouteForPlatform } from '@/services/platformRouting'
import privilegeService from '@/services/privilege.service'


export default {
  __name: 'BotMessage',
  props: { message: { type: Object, required: true } },
  setup(__props) {

const CARDS = {
  BotSlotSchedule,
  BotSlotProducts,
  BotShortfallLogged,
  BotSmsOptOutSummary,
  BotCustomerSegments,
  BotGeocodingCoverage,
  BotMethodList,
  BotDeliveryZone,
  BotMenuList,
  BotOrderSummary,
  BotProductList,
  BotProductDetail,
  BotCategoryList,
  BotInventoryReport,
  BotDiscountCodeList,
  BotPricingTierList,
  BotFulfillmentMethodList,
  BotTaxSetup,
  BotStoreProfile,
  BotEcommerceOrderSummary,
  BotError,
  BotOrderTotalBreakdown,
  BotFeeConfig,
  BotSmartlistList,
  BotSmartlistDiagnosis,
  BotLineItemBreakdown,
  BotOrderAddress,
  BotCustomerContact
}
const props = __props
const router = useRouter()
const store = useStore()

function isOpenablePath(path) {
  try {
    if (!router.resolve(path).matched.length) return false
  } catch (e) {
    return false
  }
  return canAccessRouteForPlatform(path, store.getters.activePlatform) && privilegeService.canAccessRoute(path)
}

function onContentClick(event) {
  const href = botLinkTarget(event)
  if (!href) return
  event.preventDefault()
  router.push(href)
}

const bubbleClasses = computed(() => messageBubbleClasses(props.message.role))
const renderedContent = computed(() => resolveBotLinks(renderBotMarkdown(props.message.content), isOpenablePath))
const cards = computed(() =>
  (props.message.render_blocks || [])
    .map(block => ({
      component: CARDS[renderBlockComponent(block.type)],
      block: normalizeRenderBlock(block)
    }))
    .filter(entry => entry.component)
)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.message.role === 'assistant')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_unref(SparklesIcon), { class: "h-4 w-4 text-catering-honey-500" })
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(bubbleClasses.value)
          }, [
            _createElementVNode("div", {
              class: "prose prose-sm max-w-none text-catering-ink-900",
              onClick: onContentClick,
              innerHTML: renderedContent.value
            }, null, 8, _hoisted_4)
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(bubbleClasses.value)
        }, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.message.content), 1)
        ], 2)),
    (__props.message.failed)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Not sent — please try again."))
      : _createCommentVNode("", true),
    (cards.value.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["w-full max-w-lg space-y-1.5", { 'pl-9': __props.message.role === 'assistant' }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards.value, (card, i) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(card.component), {
              key: i,
              block: card.block
            }, null, 8, ["block"]))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

}